/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const Filters = (() => {

	const DOM = {};

	const cacheDOM        = () => {
		DOM.filtersToggle = document.getElementsByClassName( "filter-toggle" );
		DOM.toggleContent = document.getElementsByClassName( "filter-options" );
	};

	const openFilters = (index) => {
		DOM.filtersToggle[index].classList.add( "open" );
		DOM.toggleContent[index].classList.add( "open" );
	};

	const closeFilters = (index) => {
		DOM.filtersToggle[index].classList.remove( "open" );
		DOM.toggleContent[index].classList.remove( "open" );
	};

	const isFiltersOpen = (index) => {
		return DOM.filtersToggle[index].classList.contains( "open" );
	};

	const toggleFilters = (index) => {
		if ( ! isFiltersOpen( index )) {
			openFilters( index );
		} else {
			closeFilters( index );
		}
	};

	const eventListeners        = () => {
		let filtersToggleLength = DOM.filtersToggle.length;
		for (let i = 0; i < filtersToggleLength; i += 1) {
			DOM.filtersToggle[i].addEventListener( "click", () => toggleFilters( i ) );
		}

	};

	const init = () => {
		cacheDOM();
		eventListeners();
	};

	return {
		init,
	};
})();

export default Filters;
